import { render, staticRenderFns } from "./ProcessVertragHeader.vue?vue&type=template&id=429f46b5&"
import script from "./ProcessVertragHeader.vue?vue&type=script&lang=js&"
export * from "./ProcessVertragHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports